<div class="ui {{ size || 'medium' }} modal" id="{{ id }}">
    <div class="content" [class.white]="backgroundColour === 'white'">
        <div *ngIf="imageFileName" class="content__image">
            <div *ngIf="imageFileName" class="ui image small">
                <img src="/assets/images/{{ imageFileName }}" />
            </div>
        </div>
        <div class="content__body">
            <div class="ui header body__header">
                {{ headerText }}
            </div>
            <div class="body__content">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
    <div class="actions">
        <button class="ui button secondary deny">Cancel</button>
        <button class="ui button primary positive" [class.disabled]="shouldDisableConfirm">
            {{ confirmText }}
        </button>
    </div>
</div>
